// extracted by mini-css-extract-plugin
export default {"column__text":"styles_column__text__C06XT","column__text--brand":"styles_column__text--brand__8QGiv","table__container":"styles_table__container__uqFlc"};